module.exports = process.env.REACT_APP_USE_FIXTURE === '1' || false;
